import classNames from "classnames/bind";
import * as React from "react";
import { useEffect, useState } from "react";
import styles from "./Spinner.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  delay?: number;
  color?: "purple" | "white" | "gray";
  size?: number;
}

export const Spinner: React.FC<React.PropsWithChildren<Props>> = ({
  delay = 1000,
  color = "purple",
  size = 50, // TODO: Restrict allowed sizes?
}) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const className = classNameBuilder(color);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(true);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  // TODO: Extract width and height out of svg tag
  if (showSpinner) {
    return (
      <svg
        x="0"
        y="0"
        width={size}
        height={size}
        viewBox={`0 0 50 50`}
        className={className}
      >
        <circle cx="10" cy="25" r="4">
          <animateTransform
            attributeName="transform"
            type="translate"
            dur="1s"
            begin="0"
            repeatCount="indefinite"
            values="0 15;0 -15;0 15"
          />
          <animate
            attributeName="opacity"
            dur="1s"
            values="0.4;1;0.4"
            repeatCount="indefinite"
            begin="0"
          />
        </circle>
        <circle cx="24" cy="25" r="4">
          <animateTransform
            attributeName="transform"
            type="translate"
            dur="1s"
            begin="0.1"
            repeatCount="indefinite"
            values="0 10;0 -10;0 10"
          />
          <animate
            attributeName="opacity"
            dur="1s"
            values="0.6;1;0.6"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle cx="38" cy="25" r="4">
          <animateTransform
            attributeName="transform"
            type="translate"
            dur="1s"
            begin="0.2"
            repeatCount="indefinite"
            values="0 5;0 -5;0 5"
          />
          <animate
            attributeName="opacity"
            dur="1s"
            values="0.8;1;0.8"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
      </svg>
    );
  } else {
    return null;
  }
};
